import { ERROR } from '../constants/actionTypes';

const error = (errorType, errorIn) => ({
    type: ERROR,
    error: errorIn,
    errorType,
  });

export default error;
